<template>
  <div class="welcome container">
    <h1>Welcome to Login Screen</h1>
    <div v-if="showLogin">
      <LoginForm @login="enterChat" />
      <p>
        Don't have an account ?
        <span @click="showLogin = !showLogin">Register</span>
      </p>
    </div>

    <div v-if="!showLogin">
      <SignupForm @signup="enterChat" />
      <p>
        Already have an account ?
        <span @click="showLogin = !showLogin">Sign In</span>
      </p>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import LoginForm from "../components/LoginForm.vue";
import SignupForm from "../components/SignupForm.vue";
export default {
  components: { LoginForm, SignupForm },
  setup() {
    const showLogin = ref(true);
    const router = useRouter();

    const enterChat = () => {
      router.push({ name: "Chatroom" });
    };

    return { showLogin, enterChat };
  },
};
</script>

<style>
.welcome {
  text-align: center;
  padding: 20px 0px;
}
/* form styles */
.welcome form {
  width: 300px;
  margin: 20px auto;
}
.welcome label {
  display: block;
  margin: 20px 0 10px;
}
.welcome input {
  width: 100%;
  padding: 10px;
  border-radius: 20px;
  border: 1px solid #eee;
  outline: none;
  color: #999;
  margin: 10px auto;
}
.welcome span {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
.welcome button {
  margin: 20px auto;
}
</style>
